import { SvgIcon, SvgIconProps, useTheme, colors } from "@mui/material";

const AzSqlSvgIcon = ({ primary }: SvgIconProps & { primary?: boolean }) => {
  const { palette } = useTheme();

  const color = primary ? palette.primary.main : palette.action.active;
  const colorLight = primary ? colors.indigo["300"] : palette.action.disabled;

  return (
    <SvgIcon>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 6.8531C7.28004 6.8531 3.45337 5.51977 3.45337 3.75977V20.2398C3.45337 21.9331 7.21337 23.3064 11.88 23.3331H12C16.72 23.3331 20.5467 21.9998 20.5467 20.2398V3.75977C20.5467 5.47977 16.72 6.8531 12 6.8531Z"
          fill={color}
        />
        <path
          d="M20.5467 3.75935C20.5467 5.47935 16.72 6.85268 12 6.85268C7.28004 6.85268 3.45337 5.51935 3.45337 3.75935C3.45337 1.99935 7.28004 0.666016 12 0.666016C16.72 0.666016 20.5467 1.99935 20.5467 3.75935Z"
          fill={color}
          fillOpacity="0.08"
        />
        <path
          d="M18.5599 3.50688C18.5599 4.60021 15.6133 5.48021 11.9999 5.48021C8.38661 5.48021 5.43994 4.60021 5.43994 3.50688C5.43994 2.41354 8.38661 1.54688 11.9999 1.54688C15.6133 1.54688 18.5599 2.42688 18.5599 3.50688Z"
          fill={colorLight}
        />
        <path
          d="M11.9999 3.99984C10.2403 3.9549 8.48598 4.21196 6.81323 4.75984C8.48757 5.29755 10.2424 5.54116 11.9999 5.47985C13.761 5.53143 15.5172 5.26958 17.1866 4.70651C15.509 4.18397 13.7561 3.94513 11.9999 3.99984Z"
          fill={color}
          fillOpacity="0.5"
        />
        <path
          d="M17.2 15.2008V10.6674H16V16.1741H19.28V15.2008H17.2ZM7.68001 12.9741C7.43226 12.8744 7.20254 12.7348 7.00001 12.5608C6.94624 12.5039 6.90438 12.4369 6.8769 12.3636C6.84942 12.2903 6.83688 12.2123 6.84001 12.1341C6.83593 12.0558 6.8522 11.9778 6.88726 11.9077C6.92231 11.8376 6.97494 11.7778 7.04001 11.7341C7.20401 11.6206 7.40083 11.5644 7.60001 11.5741C8.0749 11.5527 8.54356 11.6887 8.93335 11.9608V10.8141C8.50736 10.6556 8.05419 10.5831 7.60001 10.6008C7.07691 10.5729 6.56119 10.7338 6.14668 11.0541C5.96601 11.1934 5.82102 11.3736 5.72366 11.5799C5.6263 11.7862 5.57935 12.0127 5.58668 12.2408C5.58668 12.9208 6.01335 13.4541 6.92001 13.8541C7.21449 13.979 7.49219 14.1403 7.74668 14.3341C7.80902 14.3864 7.8592 14.4517 7.89374 14.5254C7.92828 14.599 7.94635 14.6794 7.94668 14.7608C7.94672 14.8417 7.92736 14.9214 7.89025 14.9933C7.85313 15.0653 7.79933 15.1272 7.73335 15.1741C7.55189 15.2803 7.34336 15.3313 7.13335 15.3208C6.59706 15.3163 6.08061 15.1173 5.68001 14.7608V16.0008C6.12033 16.2278 6.61157 16.338 7.10668 16.3208C7.66555 16.3539 8.21942 16.199 8.68001 15.8808C8.84269 15.7267 8.96718 15.5368 9.04356 15.3261C9.11995 15.1155 9.14612 14.8899 9.12001 14.6674C9.12642 14.3261 9.00788 13.9941 8.78668 13.7341C8.47516 13.406 8.09811 13.147 7.68001 12.9741ZM14.6667 15.0941C14.9694 14.587 15.122 14.0044 15.1067 13.4141C15.0766 12.9143 14.9256 12.4293 14.6667 12.0008C14.4585 11.5844 14.1344 11.2371 13.7333 11.0008C13.3269 10.7704 12.8672 10.6509 12.4 10.6541C11.8964 10.643 11.3991 10.7673 10.96 11.0141C10.5484 11.2438 10.2108 11.586 9.98668 12.0008C9.75064 12.4722 9.63173 12.9936 9.64001 13.5208C9.6428 13.9839 9.7523 14.4401 9.96001 14.8541C10.1635 15.2659 10.4834 15.609 10.88 15.8408C11.2827 16.0864 11.7419 16.2241 12.2133 16.2408L13.36 17.5741H14.9733L13.3333 16.1074C13.8856 15.9418 14.3592 15.5818 14.6667 15.0941ZM13.3333 14.7608C13.2119 14.9115 13.0573 15.0321 12.8815 15.113C12.7057 15.194 12.5135 15.2332 12.32 15.2274C12.1251 15.2337 11.9315 15.1935 11.7553 15.11C11.5791 15.0265 11.4253 14.9022 11.3067 14.7474C11.0248 14.3624 10.8879 13.8902 10.92 13.4141C10.8891 12.9381 11.0259 12.4663 11.3067 12.0808C11.4322 11.9261 11.5907 11.8014 11.7707 11.7161C11.9507 11.6307 12.1475 11.5867 12.3467 11.5874C12.5414 11.579 12.7351 11.6198 12.9098 11.706C13.0846 11.7923 13.2349 11.9211 13.3467 12.0808C13.6094 12.4738 13.7358 12.9422 13.7067 13.4141C13.7532 13.8937 13.6202 14.3735 13.3333 14.7608Z"
          fill="url(#paint0_radial_551_89793)"
        />
        <defs>
          <radialGradient
            id="paint0_radial_551_89793"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(12.48 14.0941) scale(9.42667 9.42667)"
          >
            <stop stopColor="#F2F2F2" />
            <stop offset="0.58" stopColor="#EEEEEE" />
            <stop offset="1" stopColor="#E6E6E6" />
          </radialGradient>
        </defs>
      </svg>
    </SvgIcon>
  );
};

AzSqlSvgIcon.muiName = "AzSqlSvgIcon";

export default AzSqlSvgIcon;
